// Pages
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import TrackCar from 'src/components/Tracking/TrackCar.vue'
import Login from 'src/components/GeneralViews/Login.vue'

import RoutesPaths from './routesPaths'

const routes = [
  {
    path: '/',
    component: Login,
    redirect: RoutesPaths.Login
  },
  {
    path: RoutesPaths.Login,
    component: Login
  },
  {
    path: RoutesPaths.Main,
    component: TrackCar
  },
{ path: '*', component: NotFound }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js